import script from "./PricingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingSection.vue?vue&type=script&setup=true&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=599f002b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-599f002b"]])

export default __exports__